var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBerkeleyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 72,
    viewBox: "0 0 189 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 189,
    height: 72,
    transform: "translate(2032 -225.897)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_109",
    "data-name": "Mask Group 109",
    transform: "translate(-2032 225.897)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(2032 -212.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "The-Berkeley_London_for-web"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M65.4,11.98c0,2.472.54,3.169,3.385,3.169,2.284,0,3.323-1.395,3.323-3.655,0-3.254-1.994-3.761-5.067-3.761H65.4ZM66.048.7c-.582.042-.644.063-.644.761V7.1h1.537c2.035,0,3.759-.549,3.759-3.233A2.867,2.867,0,0,0,67.5.655C67.107.655,66.63.655,66.048.7ZM73.441,3.74c0,1.881-1.744,2.916-3.51,3.465v.042c2.7.3,5.212,1.754,5.212,4.458,0,3.507-3.343,4.078-5.96,4.078-1.371,0-3.7-.063-4.859-.063s-2.367.042-3.551.063v-.549c2.2-.021,2.243-.592,2.243-3.93V4.479c0-3.317-.042-3.93-2.243-3.93V0c1.5,0,1.89.063,3.551.063S66.609,0,67.668,0c2.492,0,5.773.571,5.773,3.74Z",
    transform: "translate(-3.117)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M90.152,3.7C89.716.95,88.512.781,86.061.781H84.233c-.581,0-.644.042-.644.782V7.141c.395.021.478.021.644.021,2.887,0,3.136-1.331,3.281-2.916h.54c-.021,1.057-.1,2.049-.1,3.212,0,.951.083,1.944.1,2.916h-.54c-.312-2.472-1.391-2.6-3.925-2.6v4.1c0,2.472.54,3.233,3.385,3.169,2.409-.042,3.987-.359,4.3-3.148h.519l-.208,3.8c-2.347,0-4.652-.063-6.978-.063-1.869,0-4.361.063-5.628.063v-.549c2.2-.021,2.243-.591,2.243-3.93V4.584c0-3.317-.042-3.93-2.243-3.93V.1c1.5,0,3.3.064,4.963.064C86.372.168,88.636.1,90.692.1V3.7h-.54",
    transform: "translate(-4.05 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M100.86,7.669c.623.021,1.225.021,1.744.021,1.765,0,3.032-.7,3.032-3.36,0-2.071-1.142-3.571-3.24-3.571A10.016,10.016,0,0,0,101.338.8c-.457.043-.478.127-.478.761ZM103,.1c2.637,0,5.316.613,5.316,3.888,0,2.2-1.474,3.465-3.966,4.014l4.61,5.768a3.01,3.01,0,0,0,2.513,1.373V15.7c-.706,0-1.557-.063-2.264-.063-.582,0-1.142.063-1.723.063-.374-.528-.706-.993-1.1-1.5L102.5,9.19c-.685-.866-.81-.887-1.641-.887v4.12c0,2.239.083,2.662,2.284,2.725V15.7c-1.121-.021-2.222-.063-3.364-.063-1.163,0-2.347.042-3.53.063v-.549c2.2-.021,2.243-.612,2.243-3.93V4.584c0-3.3-.042-3.909-2.243-3.93V.1c1.184.021,2.368.064,3.53.064S101.836.1,103,.1Z",
    transform: "translate(-4.936 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M118.519,8.514l4.133-4.374c1.433-1.521,1.807-2.155,1.807-2.7,0-.634-.581-.74-1.744-.782V.1c.955,0,1.828.064,2.762.064.81,0,1.952-.064,2.783-.064v.55a3.067,3.067,0,0,0-2.72,1.31l-4.257,4.458,4.755,5.684c2.181,2.641,2.6,2.937,4.133,3.042V15.7c-1.267,0-2.741-.063-3.966-.063-1.184,0-2.181.063-3.385.063v-.549c1.557-.063,1.765-.38,1.765-.8s-.332-.845-1.2-1.881l-3.634-4.437-1.225,1.289v3.106c0,2.239.083,2.662,2.284,2.725V15.7c-1.121-.021-2.222-.063-3.364-.063-1.163,0-2.347.042-3.53.063v-.549c2.2-.021,2.243-.612,2.243-3.93V4.584c0-3.3-.042-3.909-2.243-3.93V.1c1.184.021,2.367.064,3.53.064,1.142,0,2.243-.042,3.364-.064v.55c-2.2.063-2.284.7-2.284,2.937V8.514",
    transform: "translate(-5.841 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M144.1,3.7C143.666.95,142.461.781,140.011.781h-1.828c-.581,0-.644.042-.644.782V7.141c.395.021.478.021.644.021,2.887,0,3.136-1.331,3.281-2.916H142c-.021,1.057-.1,2.049-.1,3.212,0,.951.083,1.944.1,2.916h-.54c-.312-2.472-1.391-2.6-3.925-2.6v4.1c0,2.472.54,3.233,3.385,3.169,2.409-.042,3.987-.359,4.3-3.148h.519l-.208,3.8c-2.346,0-4.652-.063-6.977-.063-1.869,0-4.361.063-5.628.063v-.549c2.2-.021,2.243-.591,2.243-3.93V4.584c0-3.317-.042-3.93-2.243-3.93V.1c1.5,0,3.3.064,4.963.064,2.43,0,4.693-.064,6.749-.064V3.7h-.54",
    transform: "translate(-6.817 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M154.2,4.584l.021,7.29c0,2.472.457,3.169,3.593,3.169,2.7,0,4.195-.571,4.61-3.529H163l-.208,4.183c-2.347,0-5.233-.063-7.559-.063-1.869,0-4.361.063-5.627.063v-.549c2.2-.021,2.243-.591,2.243-3.93V4.584c0-3.317-.042-3.93-2.243-3.93V.1c1.184.021,2.367.064,3.53.064,1.142,0,2.263-.042,3.385-.064v.55c-2.2,0-2.326.613-2.326,3.93",
    transform: "translate(-7.672 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M177.386,3.7C176.95.95,175.746.781,173.3.781h-1.828c-.581,0-.644.042-.644.782V7.141c.395.021.478.021.644.021,2.887,0,3.136-1.331,3.281-2.916h.54c-.021,1.057-.1,2.049-.1,3.212,0,.951.083,1.944.1,2.916h-.54c-.311-2.472-1.391-2.6-3.925-2.6v4.1c0,2.472.54,3.233,3.385,3.169,2.409-.042,3.987-.359,4.3-3.148h.519l-.208,3.8c-2.347,0-4.652-.063-6.977-.063-1.869,0-4.361.063-5.628.063v-.549c2.2-.021,2.243-.591,2.243-3.93V4.584c0-3.317-.042-3.93-2.243-3.93V.1c1.5,0,3.3.064,4.963.064,2.43,0,4.693-.064,6.749-.064V3.7h-.54",
    transform: "translate(-8.524 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M186.57,15.7v-.549c2.2-.063,2.347-.486,2.347-2.725v-2.6l-4.049-6.55c-1.2-1.965-1.6-2.514-3.115-2.62V.1c1.038,0,2.326.064,3.385.064,1.08,0,2.222-.064,3.323-.064v.55c-1.2.042-1.724.3-1.724.866a2.253,2.253,0,0,0,.478,1.289l3.738,5.9,3.24-5.282a3.143,3.143,0,0,0,.665-1.775c0-.761-.623-.93-1.6-.993V.1c.851,0,1.578.064,2.409.064.768,0,1.682-.064,2.45-.064v.55c-1.267.042-1.744.528-2.6,1.944L191.3,9.486v2.937c0,2.239.145,2.662,2.347,2.725V15.7c-1.121-.021-2.388-.063-3.53-.063s-2.429.042-3.551.063",
    transform: "translate(-9.321 -0.005)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M50.43,3.762C49.995,1.015,48.79.846,46.34.846H44.512c-.581,0-.644.042-.644.782V7.206c.395.021.478.021.644.021,2.887,0,3.136-1.331,3.281-2.916h.54c-.021,1.056-.1,2.049-.1,3.212,0,.951.083,1.944.1,2.916h-.54c-.311-2.472-1.391-2.6-3.925-2.6v4.1c0,2.472.54,3.233,3.385,3.169,2.409-.042,3.987-.359,4.3-3.148h.519l-.208,3.8c-2.347,0-4.652-.063-6.977-.063-1.869,0-4.361.063-5.628.063v-.549c2.2-.021,2.243-.592,2.243-3.93V4.649c0-3.317-.042-3.93-2.243-3.93V.17c1.5,0,3.3.063,4.963.063,2.43,0,4.693-.063,6.749-.063V3.762h-.54",
    transform: "translate(-2.013 -0.009)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M.533,3.783H0S.01.23.009.224C3.2.24,11.187.27,14.351.224c-.018,0,0,3.548,0,3.548l-.523.01C13.5,1.444,12.462.852,10.279.852H8.257l.053,12.1c.03,1.155-.182,2.33,2.272,2.293,0,0,0,.542,0,.538-3.822-.14-6.887-.01-6.887-.01v-.538c.092,0,.184,0,.276,0,1.542-.035,1.958-.634,1.947-2.263L5.985.856H4.169C1.94.856.888,1.374.533,3.783",
    transform: "translate(0 -0.012)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M24.982.175c0,.028-.015.554-.015.554-1.247,0-2.28.031-2.277,2.264l-.052,4.175h7.975V3c.009-1.6-.173-2.292-2.267-2.3l.007-.53s3.479.156,6.915.014l-.01.539c-1.809-.085-2.18.519-2.25,2.289l-.022,9.517c.038,2.161.311,2.671,2.085,2.678h.161s.01.566-.006.578c-2.963-.2-6.846-.028-6.846-.028V15.21c.539-.128,2.287.259,2.226-1.69l.006-5.7H22.637l0,5.7c.046,1.593.775,1.578,2.082,1.716.069,0,.152.016.2.016v.51a57.617,57.617,0,0,0-6.858.011v-.538H18.2c1.886-.061,2.038-.788,2.053-2.721L20.3,3.02C20.285,1.285,19.92.7,18.063.727V.189S21.41.274,24.982.175",
    transform: "translate(-0.926 -0.009)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M73.176,29.591h52.863V28.86H73.176Z",
    transform: "translate(-3.753 -1.48)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M73.176,47.264V40.3h.658v6.361h3.289v.6H73.176",
    transform: "translate(-3.753 -2.067)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M83.482,40.825a2.953,2.953,0,1,0,2.909,2.952A2.942,2.942,0,0,0,83.482,40.825Zm0,6.547a3.595,3.595,0,1,1,3.567-3.594,3.576,3.576,0,0,1-3.567,3.594Z",
    transform: "translate(-4.098 -2.061)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M96.479,47.264l-4.6-5.894v5.894h-.658V40.3h.658l4.6,5.894V40.3h.658v6.961h-.658",
    transform: "translate(-4.678 -2.067)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M103.8,40.9h-1.254v5.76H103.7a2.894,2.894,0,1,0,.1-5.76Zm.1,6.36h-2.015V40.3H103.9a3.486,3.486,0,1,1,0,6.961Z",
    transform: "translate(-5.225 -2.067)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M114.806,40.825a2.953,2.953,0,1,0,2.909,2.952A2.942,2.942,0,0,0,114.806,40.825Zm0,6.547a3.595,3.595,0,1,1,3.567-3.594,3.576,3.576,0,0,1-3.567,3.594Z",
    transform: "translate(-5.705 -2.061)",
    fill: "#003564",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M127.8,47.264,123.2,41.37v5.894h-.658V40.3h.658L127.8,46.2V40.3h.658v6.961H127.8",
    transform: "translate(-6.284 -2.067)",
    fill: "#003564",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerkeleyLogo);
export default __webpack_public_path__ + "static/media/berkeley-logo.f30e1710945070fa42c8dac657d62240.svg";
export { ForwardRef as ReactComponent };